export const CHANGE_VIEW = 'CHANGE_VIEW';

export const changeView = view => ({
    type: CHANGE_VIEW,
    payload: view
  });
  